/** 可用于规范化报告地址的浏览器 Location 子集。 */
export interface ReportRouteLocation {
    /** URL 协议、主机和端口。 */
    readonly origin: string;
    /** URL 查询参数。 */
    readonly search: string;
    /** URL hash 路由。 */
    readonly hash: string;
}

const SUPPORTED_REPORT_ROUTES = new Set([
    '/novelty-check-report',
    '/fto-pro',
]);
const CHECKING_ROUTE_PREFIX = '/ip/checking/';
const NESTED_HASH_MARKER = '/#/';

/**
 * 将外层产品 hash 中嵌套的查新或 FTO Pro 路由转换为应用可直接匹配的 URL。
 *
 * @returns 需要替换的新 URL；当前地址已经可匹配时返回 null。
 */
export function getNormalizedNestedReportUrl(location: ReportRouteLocation): string | null {
    const nestedHashIndex = location.hash.indexOf(NESTED_HASH_MARKER);
    if (nestedHashIndex < 0) {
        return null;
    }

    const applicationPath = location.hash.slice(1, nestedHashIndex + 1);
    if (applicationPath !== CHECKING_ROUTE_PREFIX) {
        return null;
    }

    const reportHash = location.hash.slice(nestedHashIndex + 1);
    const reportPath = reportHash.slice(1).split('?')[0];
    if (!SUPPORTED_REPORT_ROUTES.has(reportPath)) {
        return null;
    }

    return `${location.origin}${applicationPath}${location.search}${reportHash}`;
}
